import { Action, Reducer } from "redux";
import { BpiCategory, BpiCategoryDetails } from "../entities/BpiEntities";
import { AppThunkAction } from "./";

// -----------------------------------------------------------------------------------------------
// state

export interface BpiState {
    categories: BpiCategory[],
    categoryDetails: BpiCategoryDetails
}

// ------------------------------------------------------------------------------------------------
// actions

const SET_CATEGORIES = 'SET_CATEGORIES';

const SET_CATEGORY_DETAILS = 'SET_CATEGORY_DETAILS';

interface SetCategoriesAction {
    type: typeof SET_CATEGORIES;
    categories: BpiCategory[];
}

interface SetCategoryDetails{
    type: typeof SET_CATEGORY_DETAILS;
    categoryDetails: BpiCategoryDetails;
}

type KnownAction = SetCategoriesAction | SetCategoryDetails

export const actionCreators = {
    setCategories: (categories: BpiCategory[]): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({
            type: SET_CATEGORIES,
            categories
        })
    },
    setCategoryDetails: (categoryDetails: BpiCategoryDetails): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({
            type: SET_CATEGORY_DETAILS,
            categoryDetails
        })
    }
};

// ------------------------------------------------------------------------------------------------
// reducer

export const reducer: Reducer<BpiState, KnownAction> = (state: BpiState | undefined, incomingAction: Action): BpiState => {
    if (state === undefined) {
        return {
            categories: [],
            categoryDetails: null,
        };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case SET_CATEGORIES:
            return {
                ...state,
                categories: action.categories
            };
        case SET_CATEGORY_DETAILS:
            return{
                ...state,
                categoryDetails: action.categoryDetails
            }
        default:
            return state;
    }
};
